<template>
  <div id="app">
    <router-view name="outer"></router-view>
    <el-container v-if="$route.name !== 'login'">
      <el-header>
        <router-view name="header"></router-view>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { UserStore } from "@/store";

export default {
  name: "app",
  store: { user: UserStore },
  async created() {
    axios.defaults.headers["Content-Type"] = "application/json";
    if (window.localStorage) {
      const token = window.localStorage.getItem("acloud-user-token");
      if (token) {
        this.$router.onReady(async () => {
          try {
            await this.$store.user.dispatch("loginJwt", { token });
            axios.defaults.headers["Authorization"] = `Bearer ${token}`;
            
            if (this.$route.name !== 'admin') {
              this.$message(
                `${this.$t('autologinas')} ${this.$store.user.state.username}`
              );
              this.$router.push("dashboard");
            }
          } catch (e) {
            window.localStorage.removeItem("acloud-user-token");
            if (this.$route.name !== 'admin') {
              this.$router.push("login");
            }
          }
        });
      }
    }
  }
};
</script>

<style>
.el-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fcfcfd;
  z-index: 1;
  box-shadow: 0 0 10px rgb(0, 0, 0, .1);
}
.el-main {
  margin-top: 60px;
}
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
